interface CircularProgressProps {
  size?: number;
  thickness?: number;
  className?: string;
  props?: React.ComponentProps<"div">;
}

export const CircularProgress: React.FC<CircularProgressProps> = ({
  size = 40,
  thickness = 3.6,
  className = "",
  ...props
}) => {
  const radius = size / 2 - thickness;
  const center = size / 2;
  const circumfrence = 2 * Math.PI * radius;
  const strokeDashArray = `${circumfrence * 0.5} ${circumfrence}`;

  return (
    <div
      className={`inline-block ${className}`}
      style={{ width: size, height: size }}
      {...props}
    >
      <svg
        width={size}
        height={size}
        className="animate-spin"
        style={{
          animationDuration: "1.4s",
          animationTimingFunction: "linear",
          animationIterationCount: "infinite",
        }}
      >
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="#00733b"
          strokeWidth={thickness}
          strokeLinecap="round"
          strokeDasharray={strokeDashArray}
          style={{ transformOrigin: "50% 50%", transform: "rotate(-90deg)" }}
        />
      </svg>
    </div>
  );
};
